import FormMessageHandler from '../components/formMessageHandler';

const body = $('body');
if(body.hasClass('page--reset-password-email')) {
  class ResetPassword {
    constructor() {
      let Spinner = require('spin');
      this.cacoo = require('../components/cacoo').cacoo;

      this.$resetPasswordForm = $('.account-form__forget-password-form', body);
      this.$email = $('#email', this.$resetPasswordForm);
      this.$forgetPasswordSuccess = $('.account-form__forget-password-success', body);
      this.$sendButton = $('.js_forget_password_send', this.$resetPasswordForm);
      this.formMessageHandler = new FormMessageHandler(this.$resetPasswordForm);

      this.buttonSpinner = new Spinner({color: '#fff', lines: 12});

      this.attachEvent();
    }

    attachEvent() {
      this.$sendButton.on('click', () => {
        this.sendResetPasswordEmail();
      });

      this.$email.on('keypress', (e) => {
        if(e.which === 13) {
          this.sendResetPasswordEmail();
        }
      });

    }

    sendResetPasswordEmail() {
      if(this.$sendButton.hasClass('disable') || !this.mailValidate()){
        return false;
      }
      const description = this.cacoo.util.getResourceWithArg(Cacoo.SiteResources['reset_password_success_description'], [this.$email.val()]);
      $('h4', this.$forgetPasswordSuccess).html(description);

      const data = {
        email: this.$email.val()
      };
      this.cacoo.ajax({
        url: `${Cacoo.settings.baseUrl}/api/site/resetPasswordEmail`,
        method: "POST",
        data: data,
        beforeSend: () => {
          this.startButtonSpinner();
        },
        success: () => {
          this.stopButtonSpinner();
          this.showSuccessMessage();

        },
        error: (err) => {
          this.stopButtonSpinner();
          const jsonResponse = err.responseJSON;
          if(jsonResponse.errors) {
            for(let i = 0; i < jsonResponse.errors.length; i++) {
              const error = jsonResponse.errors[i];
              this.formMessageHandler.showError(error.field, error.message);
            }
          } else {
            this.formMessageHandler.showError('default', Cacoo.SiteResources['modal_signup_default_error']);
          }
        },
        timeout: 30000
      });

    }

    mailValidate() {
      if (!this.cacoo.util.validateEmail(this.$email.val())) {
        this.formMessageHandler.showError('email', Cacoo.SiteResources['modal_signup_email_error']);
        return false;
      } else {
        this.formMessageHandler.removeError('email');
      }

      return true;
    }

    showSuccessMessage() {
      this.$resetPasswordForm.hide();
      this.$forgetPasswordSuccess.show();
    }

    startButtonSpinner() {
      this.$sendButton.addClass('disable');
      this.buttonSpinner.spin(this.$sendButton.get(0));
    }

    stopButtonSpinner() {
      this.$sendButton.removeClass('disable');
      this.buttonSpinner.stop();
    }
  }

  new ResetPassword();
}
